export default {
  maxUnitsAvailable: {
    id: 'article_quantity_selector_cart_only_x_units_available',
    defaultMessage: 'Only {max} units are available for this merchant. 😔',
  },
}
